import { MarketSummaryDisplaysTab } from '@/pages/instruments/market-summary/components/MarketSummaryDisplaysTab'
import { MarketSummaryEventsTab } from '@/pages/instruments/market-summary/components/MarketSummaryEventsTab'
import { MarketSummaryInstrumentsTab } from '@/pages/instruments/market-summary/components/MarketSummaryInstrumentsTab'
import { MARKET_SUMMARY_TABS, MarketSummaryTab } from '@/pages/instruments/market-summary/market-summary-context'

export const tabs: { label: string; value: MarketSummaryTab; component: React.ComponentType }[] = [
  {
    label: 'Report',
    value: MARKET_SUMMARY_TABS.DISPLAYS,
    component: MarketSummaryDisplaysTab,
  },
  {
    label: 'Instruments',
    value: MARKET_SUMMARY_TABS.INSTRUMENTS,
    component: MarketSummaryInstrumentsTab,
  },
  {
    label: 'Events',
    value: MARKET_SUMMARY_TABS.EVENTS,
    component: MarketSummaryEventsTab,
  },
]
